import React from 'react'
import { FaStar } from 'react-icons/fa'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export default function Rating({ score, avs }) {
  if (score) {
    return (
      <Box sx={stMob.containAvaliacao}>
        <FaStar size={13} />
        <Typography variant='body1' sx={{ fontFamily: 'jost-light', fontWeight: 'bold', fontSize: '12px', marginLeft: '5px' }}>
          {score.toFixed(1).toString().replace('.', ',')} ({avs})
        </Typography>
      </Box>
    )
  } else {
    return (
      <Box sx={stMob.containAvaliacao}>
        <Typography variant='body1' sx={{ fontFamily: 'jost-light', fontWeight: 'bold', fontSize: '12px' }}>
          Novidade!
        </Typography>
      </Box>
    )
  }
}

const stMob = {
  containAvaliacao: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'orange',
  },
}
